import React from 'react';
import PropTypes from 'prop-types';

import { Badge, Card } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';
import ConcurrentSyncRow from 'components/data_sources/single_data_source_view/ConcurrentSyncRow';
import DATA_SOURCE_CATEGORY from 'lib/enums/DataSourceCategory';

/**
 * Component to display all currently running GDSN syncs for a data source
 * Allows monitoring of multiple concurrent sync processes
 */
function ConcurrentGDSNSyncs({ inProgressRuns, dataSource, loading = false }) {
  // Only show for GDSN data sources with active runs
  if (dataSource?.source_type !== DATA_SOURCE_CATEGORY.GDSN || !inProgressRuns?.length) {
    return null;
  }

  return (
    <Card className="mt-3">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <div>
          <h6 className="mb-0">🔄 Active GDSN Syncs ({inProgressRuns.length})</h6>
          <small className="text-muted">
            Multiple concurrent syncs are running for this GDSN data source
          </small>
        </div>
        {loading && (
          <Badge variant="primary" className="animate-pulse">
            Refreshing...
          </Badge>
        )}
      </Card.Header>
      <Card.Body className={css(styles.cardBody)}>
        {inProgressRuns.map(run => (
          <ConcurrentSyncRow key={run.id} run={run} />
        ))}
      </Card.Body>
    </Card>
  );
}

const styles = StyleSheet.create({
  cardBody: {
    paddingTop: '0.75rem',
    paddingBottom: '0.75rem',
  },
});

// PropTypes validation
ConcurrentGDSNSyncs.propTypes = {
  inProgressRuns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      date_created: PropTypes.string.isRequired,
      run_metadata: PropTypes.shape({
        manufacturer: PropTypes.string,
        manufacturer_glns: PropTypes.arrayOf(PropTypes.string),
        current_row: PropTypes.number,
        total_rows: PropTypes.number,
        processed_count: PropTypes.number,
        error_count: PropTypes.number,
      }),
    }),
  ).isRequired,
  dataSource: PropTypes.shape({
    source_type: PropTypes.string.isRequired,
  }).isRequired,
  loading: PropTypes.bool,
};

export default ConcurrentGDSNSyncs;
